import { createStore } from 'zustand'
import type { BeforeInstallPromptEvent } from './helpers/install-app'

type GlobalStore = {
  freshChatMessages: number
  installPwaPrompt: BeforeInstallPromptEvent | null
  setFreshChatMessages: (value: number) => void
  setDeferredPrompt: (value: BeforeInstallPromptEvent | null) => void
}

export const globalStore = createStore<GlobalStore>(set => ({
  freshChatMessages: 0,
  installPwaPrompt: null,
  setFreshChatMessages: (value: number) => set({ freshChatMessages: value }),
  setDeferredPrompt: (value: BeforeInstallPromptEvent | null) => set({ installPwaPrompt: value }),
}))
